/**
 * RTWO Blockchain Core Foundation — In-Memory Block Repository
 * RTWO v2.2 | Module ID: RTWO-BLCK-001
 *
 * Empty store — no mock blocks. Backend reports disconnected by default.
 */

import type { BlockchainCoreBlock } from '../domain-models';
import type { IBlockchainCoreBlockRepository } from './block-repository-interface';

export class InMemoryBlockRepository implements IBlockchainCoreBlockRepository {
  private readonly store = new Map<string, BlockchainCoreBlock>();

  isBackendConnected(): boolean {
    return false;
  }

  findLatest(): BlockchainCoreBlock | null {
    const blocks = Array.from(this.store.values()).sort((a, b) => {
      const left = a.blockNumber ? BigInt(a.blockNumber) : BigInt(0);
      const right = b.blockNumber ? BigInt(b.blockNumber) : BigInt(0);
      return right > left ? 1 : right < left ? -1 : 0;
    });
    return blocks[0] ?? null;
  }

  findByNumber(blockNumber: bigint): BlockchainCoreBlock | null {
    return (
      Array.from(this.store.values()).find(
        (block) => block.blockNumber === blockNumber.toString()
      ) ?? null
    );
  }

  findByHash(blockHash: string): BlockchainCoreBlock | null {
    return this.store.get(blockHash) ?? null;
  }

  count(): number {
    return this.store.size;
  }
}
